// extracted by mini-css-extract-plugin
export default {"paper":"checkout_paper__f5mhy","cta":"checkout_cta__xvW4u","glow":"checkout_glow__otvYG","highlight":"checkout_highlight__Z-G52"};